import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';

const Routers = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);
    const [currentLoadingItem, setCurrentLoadingItem] = useState('');

    return (
        <div className='routers-wrapper'>
            {
                props.routers && props.routers.map(function (item, index) {
                    return (
                        <div className='router-item-wrapper' key={index}>
                            {
                                item.cmsData?.labelText &&
                                <div className='router-label'> {item.cmsData?.labelText} </div>
                            }

                            <input type='radio' name='router' className='input-radio' id={`input-radio-${index}`} />
                            <label className='router-item' htmlFor={`input-radio-${index}`} onClick={() => selectRouter(item)}>
                                {
                                    props.isLoadingShoppingCart && currentLoadingItem == item.name &&
                                    <div className='router-loader'></div>
                                }
                                <div className='details-wrapper'>
                                    <div className='router-details'>
                                        {item.isForeignRouter ? 'לא, יש לי כבר נתב' : item.billDescription}
                                    </div>
                                    {
                                        !item.isForeignRouter &&
                                        <div className='router-price'>
                                            {parseFloat(item.price) > 0 ? `₪${item.price} לחודש` : 'ללא עלות'}
                                        </div>
                                    }
                                </div>
                                {
                                    item.cmsData?.description &&
                                    <div className='router-description'> {item.cmsData?.description} </div>
                                }
                            </label>
                        </div>
                    );
                })
            }

            {props.errorMsg && <p className='error-msg'>{props.errorMsg}</p>}

            {
                props.routerPopupText &&
                <div className='open-popup-link-wrapper'>
                    <a className='open-popup-link' href='#' onClick={() => setIsDisplayPopup(true)}>
                        <Image src={Config.epiBaseUrl + props.routerImage} />
                        למה אני צריך נתב?
                    </a>

                    <PopUp showPopUp={isDisplayPopup} onClose={() => setIsDisplayPopup(false)} footerBtn={{ text: 'הבנתי, תודה', onBtnClick: handleClosePopup }}>
                        <div className='popup-title'>למה אני צריך נתב?</div>
                        <div className='popup-image'><Image src={Config.epiBaseUrl + props.routerImage} /></div>
                        <div dangerouslySetInnerHTML={{ __html: props.routerPopupText }}></div>
                    </PopUp>
                </div>
            }

        </div>
    );

    function selectRouter(item) {
        setCurrentLoadingItem(item.name);
        props.onSelectRouter(item);
    }

    function handleClosePopup() {
        setIsDisplayPopup(false);
    }

};
export default Routers;